import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'

const useStyles = makeStyles(theme => ({
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.layout.gap.g5
  }
}))

function FlexRow ({ children, className, style, ...rest }) {
  const classes = useStyles()
  return (
    <div {...rest} className={clsx(classes.flexRow, className)} style={style}>{children}</div>
  )
}

FlexRow.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  style: PropTypes.object
}

export default FlexRow
